module.exports = __webpack_public_path__ + "static/media/driver-fc.eb2a0192.svg";